import APIClient from '@/shared/http/clients/api'

const resourceName = 'ajuizamento'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=name,asc&size=500`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?${document}&page=${index}&size=${limit}`, config)
const FindAllByCardVinculado = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/card/${id}`, config)
const ChangeStatus = (id, data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/complete/${id}/`, data, config)

const EmployeeRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete,
  Search,
  FindAllByCardVinculado,
  ChangeStatus
}

export default EmployeeRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/ajuizamento.js